module.exports = __webpack_public_path__ + "07_long_gold.c3667534.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/07_long_gold.png
// module id = 7Rih
// module chunks = 0